import { defineMessages } from 'react-intl-next';

export default defineMessages({
	tabNameInputLabel: {
		id: 'navigation-kit-ui-tab-list.tab-rename-form.tab-name-input-label',
		defaultMessage: 'Tab name',
		description:
			'This text is used as aria-label text for the input element in the tab rename form',
	},
});
